export {
  default,
  type OwnProps as SpinnerContextProps,
  SpinnerContextProvider
} from './SpinnerContext';
